module.exports = __webpack_public_path__ + "img/logo_black.a54f10cc.png";